import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { WebhookStatsCards } from '@/components/webhooks/WebhookStatsCards';
import { WebhookList } from '@/components/webhooks/WebhookList';
import { WebhookConfigModal } from '@/components/webhooks/WebhookConfigModal';
import { WebhookLogsViewer } from '@/components/webhooks/WebhookLogsViewer';
import { WebhookTester } from '@/components/webhooks/WebhookTester';
import { type WebhookConfig } from '@/hooks/useWebhookConfigs';

export default function WebhookManagement() {
  const [selectedConfig, setSelectedConfig] = useState<WebhookConfig | null>(null);
  const [configModalOpen, setConfigModalOpen] = useState(false);

  const handleConfigClick = (config: WebhookConfig) => {
    setSelectedConfig(config);
    setConfigModalOpen(true);
  };

  return (
    <div className="space-y-6">
      <WebhookStatsCards />

      <Tabs defaultValue="list" className="w-full">
        <TabsList>
          <TabsTrigger value="list">Webhooks</TabsTrigger>
          <TabsTrigger value="logs">Logs</TabsTrigger>
          <TabsTrigger value="tester">Testador</TabsTrigger>
        </TabsList>

        <TabsContent value="list" className="mt-4">
          <WebhookList onConfigClick={handleConfigClick} />
        </TabsContent>

        <TabsContent value="logs" className="mt-4">
          <WebhookLogsViewer />
        </TabsContent>

        <TabsContent value="tester" className="mt-4">
          <WebhookTester />
        </TabsContent>
      </Tabs>

      <WebhookConfigModal
        config={selectedConfig}
        open={configModalOpen}
        onOpenChange={setConfigModalOpen}
      />
    </div>
  );
}
